import { Pipe, PipeTransform } from '@angular/core';
import { addDays } from 'date-fns';

@Pipe({
  name: 'lastOfMonth',
})
export class LastOfMonthPipe implements PipeTransform {
  // date should come in db-day-date format (yyyy-MM-dd)
  transform(dateString?: string): boolean {
    if (!dateString) return false;
    const date = new Date(dateString);
    const nextDay = addDays(date, 1);
    return date.getMonth() !== nextDay.getMonth();
  }
}
